import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { replacePlaceholders } from "../../../utils/mapping";
import { useSelector } from "react-redux";
import { BreadcrumbsState } from "../../../context/breadcrumbs/reducer";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  labelReplacers: any;
}

const Breadcrumbs = ({ labelReplacers, ...props }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------
  const { history } = useSelector(({ breadcrumbsReducer }: { breadcrumbsReducer: BreadcrumbsState }) => {
    return breadcrumbsReducer;
  });

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[Breadcrumbs] init");
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[Breadcrumbs] destroy");
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <ul className={"breadcrumbs"}>
      {history.map((b, i) => (
        <li key={b.location.key}>
          {i === history.length - 1 ? (
            <span>{replacePlaceholders(b.label, labelReplacers)}</span>
          ) : (
            <Link to={b.location.pathname}>
              <span>{replacePlaceholders(b.label, labelReplacers)}</span>
            </Link>
          )}
        </li>
      ))}
    </ul>
  );
};
export default Breadcrumbs;
